import { apiClient } from "../config";

async function editProgram(id: any, data: any) {
  const url = `/admin/programs/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editProgram;
